import { flow } from '../../../../../../util/flow';
import { twitter } from './twitter';

export const embedSocialHandler = flow(twitter);
